'use strict';
const angular = require('angular');

export default angular.module('appApp.note', [])
  .directive('note', function() {
    return {
      template: require('./note.html'),
      restrict: 'EA',
      scope: {
        noteContent: '='
      },
      link: function(scope, element, attrs) {
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/note/note.directive.js